import React from 'react';
import { TREATMENT_RECOMMENDATIONS } from 'apps/sigma2-ui/src/constants/data';
import { TreatmentRecommendation } from 'libs/end-to-end/src/treatment';
import { Pill } from 'apps/sigma2-ui/src/components/Pill';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

interface TreatmentRecommendationPillProps {
  recommendation: TreatmentRecommendation;
}

export const TreatmentRecommendationPill: React.FC<
  TreatmentRecommendationPillProps
> = (props) => {
  const language = useLanguage();

  return (
    <Pill bgClassName={TREATMENT_RECOMMENDATIONS[props.recommendation].bgColor}>
      <span className="uppercase">
        <S2Typography
          variant="small-label-alt"
          translatedContent={language[
            TREATMENT_RECOMMENDATIONS[props.recommendation].messageId
          ]()}
          textColorVariant="white"
        />
      </span>
    </Pill>
  );
};
